import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useEffect, useMemo } from 'react';
import { FormattedMessage } from 'react-intl-next';
import { ErrorScreen } from '@atlassian/generative-ai-modal/screens/Error';
import { useAnalyticsFlow, useAnalyticsFlowEventsQueue } from '../../analytics/analytics-flow/analyticsFlowUtils';
import globalMessages from '../../messages';
import { useAIExperienceCommonDataContext } from '../useAIExperienceCommonData';
export function RateLimitScreenWithLogic(_ref) {
  var loadingState = _ref.loadingState,
    errorInfo = _ref.errorInfo;
  var aiExperienceCommonData = useAIExperienceCommonDataContext();
  var endExperience = aiExperienceCommonData.endExperience,
    sendToAIExperienceMachine = aiExperienceCommonData.sendToAIExperienceMachine;
  var documentationLink = "https://support.atlassian.com/organization-administration/docs/excessive-use-in-atlassian-intelligence/";

  // https://developer.atlassian.com/platform/localization/i18n-formatting/avoiding-concatenation/#links
  var errorMsg = /*#__PURE__*/React.createElement(FormattedMessage, _extends({}, globalMessages.rateLimitEnforced, {
    values: {
      link: function link(message) {
        return /*#__PURE__*/React.createElement("a", {
          href: documentationLink,
          target: "_blank",
          rel: "noopener noreferrer"
        }, message);
      }
    }
  }));
  var analyticsFlow = useAnalyticsFlow();
  var attributes = useMemo(function () {
    return _objectSpread({
      errorType: loadingState === 'rate limit active' ? 'rate limit enforced' : 'rate limit lifted'
    }, errorInfo);
  }, [errorInfo, loadingState]);
  // Ensure the error attributes are available when the error event is fired
  useEffect(function () {
    analyticsFlow.addAttributes(attributes);
  }, [analyticsFlow, attributes]);
  useAnalyticsFlowEventsQueue({
    stepName: 'apiError',
    attributes: attributes
  });
  return /*#__PURE__*/React.createElement(ErrorScreen, {
    text: errorMsg,
    onCancel: function onCancel() {
      endExperience();
    },
    showRetryButton: false,
    onRetry: function onRetry() {
      sendToAIExperienceMachine({
        type: 'api retry'
      });
    }
  });
}